import React from 'react';
import logo from '../../assets/images/house-tau-logo.jpg';
import './BrandedLoader.css';

/**
 * Branded loading state shown while a page's key image(s) are still
 * downloading. Prevents animations (the Hero glitch, a banner's
 * zoom-in) from running against an image that isn't actually ready
 * to paint yet on a cold cache.
 *
 * `fullscreen` covers the whole viewport (used for the homepage Hero);
 * otherwise it fills its parent (used inside a page banner).
 */
export default function BrandedLoader({ fullscreen = false }) {
  return (
    <div className={`branded-loader ${fullscreen ? 'branded-loader--fullscreen' : ''}`}>
      <div className="branded-loader__ring">
        <img src={logo} alt="" className="branded-loader__logo" />
      </div>
    </div>
  );
}
